module.exports = __webpack_public_path__ + "img/lijichou.6354f1af.png";